import React from 'react';
import { translate } from '../../../../../../../../../Services/translation';
import { cn } from '../../../../../../../../../Utils/cn';

import PropTypes from 'prop-types';

const CheckoutPaymentFormDetailsForm = ({
  checkout,
  fields,
  disabled,
  onChange,
  className,
}) => {
  const { payload, errors } = checkout || {};

  if (!fields?.length) {
    return null;
  }

  return (
    <div className={cn('grid gap-4 md:grid-cols-2', className)}>
      {fields.map(
        ({ id, stateKey, type, required, autoComplete, cssClass }) => {
          const fieldName = `${stateKey}-${id}`;
          return (
            <div className={cssClass} key={fieldName}>
              <label
                className="body-sm leading-base text-label mb-1 inline-block"
                htmlFor={fieldName}
              >
                {translate(`checkout.customerinfo.${id.toLowerCase()}`)}
                {required && ' *'}
              </label>
              <input
                className="form__input"
                id={fieldName}
                name={fieldName}
                type={type || 'text'}
                value={(payload[stateKey] || {})[id] || ''}
                required={required}
                disabled={disabled}
                autoComplete={autoComplete}
                onChange={(event) => onChange(stateKey, id, event.target.value)}
              />
              {errors?.[fieldName] && (
                <p className="body-sm text-error mt-1">
                  {errors?.[fieldName]?.[0]}
                </p>
              )}
            </div>
          );
        }
      )}
    </div>
  );
};

CheckoutPaymentFormDetailsForm.propTypes = {
  checkout: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default CheckoutPaymentFormDetailsForm;
